<template>
    <div class="folders cursor-pointer w-full">
        <div class="breadcrumb" v-if="breadcrumb.length > 1">
            <el-icon class="crumb-icon">
                <Folder />
            </el-icon>
            <span v-for="(item, idx) in breadcrumb" :key="item.folder_id || item.id || idx" class="crumb"
                @click="breadcrumbFolder(item)">
                <span class="crumb-name">{{ item.name }}</span>
                <span class="crumb-sep" v-if="idx < breadcrumb.length - 1">/</span>
            </span>
        </div>
        <div class="label">文件夹（{{ folders.length }}）</div>
        <div class="folder-list">
            <div class="folder-card add" @click="onCreateFolder">
                <el-icon class="plus-icon">
                    <Plus />
                </el-icon>
                <div class="folder-name">创建文件夹</div>
            </div>
            <div class="folder-card" v-for="f in folders" :key="f.id" @click="onSelectFolder(f)"
                @mouseenter="hoverId = f.id" @mouseleave="hoverId = null"
                :class="{ 'selectborder': isFolderSelected(f.folder_id) }">
                <el-icon class="folder-icon">
                    <Folder />
                </el-icon>
                <div class="select" @click.stop="onSelect(f)" :class="{ 'multipleChoiceShow': multipleChoiceShow }">
                    <span class="select-indicator" v-if="!isFolderSelected(f.folder_id)"></span>
                    <!--  -->
                    <span class="select-indicator " v-else
                        style="border: 1px solid #2a66ff; background-color: #2a66ff;">
                        <el-icon color="white">
                            <Check />
                        </el-icon>
                    </span>
                </div>
                <div class="folder-name" v-if="editingId !== f.id">{{ f.name }}</div>
                <el-input @click.stop v-else v-model="editingName" size="small" class="folder-input w-[50px] mr-[14px]"
                    @keydown.enter="onConfirmRename(f)" @blur="onConfirmRename(f)" />
                <div class="menu-trigger" v-show="hoverId === f.id || openId === f.id || editingId === f.id" @click.stop
                    v-if="!multipleChoiceShow">
                    <el-dropdown trigger="click" @command="onFolderCommand($event, f)"
                        @visible-change="onDropdownVisibleChange($event, f)">
                        <span class="dot-btn"><el-icon>
                                <MoreFilled />
                            </el-icon></span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item command="rename">重命名</el-dropdown-item>
                                <el-dropdown-item command="move">移动</el-dropdown-item>
                                <el-dropdown-item command="copy">复制</el-dropdown-item>
                                <el-dropdown-item command="delete">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <MoveDialog v-model="moveDialogVisible" :current="moveTarget" type="folder" @confirm="onMoveConfirm"
            :action="actiontype" :corpCode="props.corpCode" :teams="[{ team_name: rootLabel, team_id: corpCode, }]" />
    </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, reactive, computed } from 'vue'
import { ElIcon, ElMessageBox, ElMessage } from 'element-plus'
import { Folder, Plus, MoreFilled } from '@element-plus/icons-vue'
import { createFolder, getFolderList, } from '@/api/affairs'
import { folderOperate } from '@/api/ResourceMasonry'
//@ts-ignore
import MoveDialog from '@/views/shared/components/MoveDialog.vue'
import { useSdkStore } from '@/stores/sdk'
import { multipleChoiceStore } from "@/stores/multipleChoice"
const multipleChoice = multipleChoiceStore()
const props = defineProps({
    rootLabel: { type: String, default: '我的空间' },
    corpCode: { type: String, default: '' }
})
const SelectFolder = computed(() => multipleChoice.getSelectFolder())
const multipleChoiceShow = computed(() => multipleChoice.multipleChoice)


const isFolderSelected = (id: any) => {
    return SelectFolder.value.includes(id)
}
const onSelect = (item: any) => {
    multipleChoice.setSelectFolder(item.folder_id)
}
const selectonClick = (item: any) => {
    if (multipleChoiceShow.value) {
        onSelect(item)
    }
}









const folders = ref<any[]>([])
const hoverId = ref<any>(null)
const openId = ref<any>(null)
const editingId = ref<any>(null)
const editingName = ref('')
const moveDialogVisible = ref(false)
const moveTarget = ref<any>(null)
const emit = defineEmits(['select', 'rename', 'move', 'copy', 'delete'])
const folderMap = reactive<any>({})
const currentFolderId = ref('')
const currentFolder = ref({})
const actiontype = ref('move')
const fetchFolders = async (parent_folder_id: string) => {
    multipleChoice.clearSelected()
    try {
        const params: any = { parent_folder_id }
        if (props.corpCode) params.corp_code = props.corpCode
        const res = await getFolderList(params)
        if (res.data?.code === 200) folders.value = res.data.data || []
    } catch { }
}

const onCreateFolder = async () => {
    multipleChoice.clearSelected()
    try {
        const { value } = await ElMessageBox.prompt('请输入文件夹名称', '创建文件夹', { confirmButtonText: '确定', cancelButtonText: '取消' })
        const name = String(value || '').trim()
        if (!name) return
        const payload: any = { name, parent_folder_id: currentFolderId.value }
        if (props.corpCode) payload.corp_code = props.corpCode
        payload.owner_type = props.corpCode ? 'team' : 'user'
        const res = await createFolder(payload)
        if (res.data?.code === 200) {
            ElMessage.success('文件夹已创建')
            await fetchFolders(currentFolderId.value)
        }
    } catch { }
}

onMounted(async () => {
    await fetchFolders('')
})

const onSelectFolder = (f: any) => {
    if (multipleChoiceShow.value) {
        selectonClick(f)
        return
    }
    currentFolderId.value = f.folder_id
    currentFolder.value = f
    fetchFolders(currentFolderId.value)
    findLastChildAndAssign(folderMap, f)
    emit('select', f)
}
const onFolderCommand = (cmd: string, f: any) => {
    if (cmd === 'rename') {
        editingId.value = f.id
        editingName.value = f.name
        return
    }
    if (cmd === 'move') {
        actiontype.value = 'move'
        moveTarget.value = f
        moveDialogVisible.value = true
        return
    }
    if (cmd === 'copy') {
        actiontype.value = 'copy'
        moveTarget.value = f
        moveDialogVisible.value = true
        return
    }
    if (cmd === 'delete') {
        ElMessageBox.confirm(`确认删除文件夹“${f.name}”？删除后不可恢复`, '删除文件夹', {
            confirmButtonText: '删除',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            await folderOperate({ kind: 'folder', action: 'delete', folder_id: f.folder_id, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode })
            // emit('delete', f)
            ElMessage.success('文件夹已删除')
            await fetchFolders(currentFolderId.value)
        }).catch(() => { })
        return
    }
    emit(cmd as any, f)
}

let hideTimer: any = null
const onDropdownVisibleChange = (visible: boolean, f: any) => {
    if (visible) {
        openId.value = f.id
        if (hideTimer) {
            clearTimeout(hideTimer)
            hideTimer = null
        }
    } else {
        if (hideTimer) clearTimeout(hideTimer)
        hideTimer = setTimeout(() => {
            if (openId.value === f.id) openId.value = null
            hideTimer = null
        }, 1000)
    }
}

const onConfirmRename = async (f: any) => {
    const name = editingName.value.trim()
    if (!name) {
        editingId.value = null
        return
    }
    const i = folders.value.findIndex(x => x.id === f.id)
    if (i > -1) folders.value[i] = { ...folders.value[i], name }

    editingId.value = null
    folderOperate({ kind: 'folder', action: 'rename', folder_id: f.id, name, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode }).then(res => {
        if (res.data?.code === 200) {

        }
    })
}
const onMoveConfirm = (payload: any) => {
    moveDialogVisible.value = false
    emit('select', currentFolder.value)
    fetchFolders(currentFolderId.value)

}
const refresh = async () => {
    await fetchFolders(currentFolderId.value)
}
defineExpose({ onCreateFolder, refresh })

const findLastChildAndAssign = (obj: any, newChild: any) => {
    if (!obj.child) {
        obj.child = newChild
    } else {
        findLastChildAndAssign(obj.child, newChild)
    }
}
function deleteChildById(obj: any, targetId: any) {
    if (obj.child) {
        if (obj.child.id === targetId) {
            delete obj.child.child
        } else {
            deleteChildById(obj.child, targetId)
        }
    }
}

const breadcrumb = computed(() => {
    const arr: any[] = [{ name: props.rootLabel, folder_id: '' }]
    let node = (folderMap as any).child
    while (node) {
        arr.push({ name: node.name, folder_id: node.folder_id, id: node.id })
        node = node.child
    }
    return arr
})

const breadcrumbFolder = (item: any) => {
    currentFolderId.value = item.folder_id
    currentFolder.value = item
    if (!item.folder_id) {
        Object.keys(folderMap).forEach(k => delete (folderMap as any)[k])
    }
    emit('select', item)
    deleteChildById(folderMap, item.id)
    fetchFolders(currentFolderId.value)
}
</script>
<style lang="scss" scoped>
.folders {
    padding: 0 24px 12px;
}

.breadcrumb {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 0px;
    border-radius: 8px;
    color: #38393b;
    font-size: 13px;
    margin-bottom: 8px;
}

.crumb-icon {
    color: #ffcc00;
}

.crumb {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
}

.crumb-name {
    color: #0b1029;
    font-weight: 600;
}

.crumb-sep {
    color: #8a8f99;
    margin: 0 8px;
}

.folders .label {
    font-size: 14px;
    color: #8a8f99;
    margin-bottom: 8px;
}

.folder-list {
    display: flex;
    align-items: center;
    gap: 16px;
    border-top: 1px solid #f0f0f0;
    padding-top: 12px;
    overflow-x: auto;
}

.folder-card {
    min-width: 200px;
    height: 56px;
    border-radius: 12px;
    border: 1px solid #eef1f5;
    background: #f5f7fa;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    padding: 0 16px;
    position: relative;
    user-select: none;
}

.folder-card.add {
    cursor: pointer;
}

.folder-card:hover {
    box-shadow: 0 6px 16px rgba(11, 16, 41, 0.08);

    .select-indicator {
        opacity: 1;
    }
}

.folder-icon {
    color: #ffcc00;
    font-size: 28px;
}

.plus-icon {
    color: #2a66ff;
    font-size: 26px;
}

.folder-name {
    max-width: 160px;
    font-size: 14px;
    color: #0b1029;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.menu-trigger {
    position: absolute;
    top: 6px;
    right: 6px;
}

.dot-btn {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 0 0 1px #e6e8eb;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #0b1029;
}

.folder-input {
    width: 100px;
}

:deep(.folder-input .el-input__wrapper) {
    box-shadow: none;
    padding: 0 10px;
    height: 28px;
}

.select-indicator {
    position: absolute;
    top: 8px;
    left: 8px;
    width: 16px;
    height: 16px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 0 0 1px #e6e8eb;
    opacity: 0;
    transition: opacity .15s ease;
}

.multipleChoiceShow {
    .select-indicator {
        opacity: 1;
    }
}

.selectborder {
    border: 2px solid #007bff;
    border-radius: 10px;
    box-sizing: border-box;
}
</style>
